/**
 * Narrow an unknown thrown value (e.g. a caught RTK Query error or a network
 * failure) down to a user-displayable message. Returns the fallback when no
 * meaningful message can be extracted.
 *
 * RTK Query mutation errors come through as `{ data: { message } }` (when the
 * backend responded with an envelope) or `{ error: '...' }` (when fetch
 * itself failed). Native Error has `.message`. Anything else falls back.
 */
export function getErrorMessage(err: unknown, fallback: string): string {
  if (typeof err === 'object' && err !== null) {
    const e = err as {
      data?: { message?: unknown; error?: unknown };
      error?: unknown;
      message?: unknown;
    };
    if (typeof e.data?.message === 'string') return e.data.message;
    // stripeController's 401/500 paths respond { error: '...' } rather
    // than the standard envelope — surfaces as data.error here.
    if (typeof e.data?.error === 'string') return e.data.error;
    if (typeof e.error === 'string') return e.error;
    if (typeof e.message === 'string') return e.message;
  }
  return fallback;
}
